// extracted by mini-css-extract-plugin
export var productImage = "_wu-0";